import { OnboardingCompanyProfile } from '__generated__/GQL';

import getCompanyComplianceModuleStatus, {
  CompanyComplianceModuleStatus,
} from '../../CompanyCompliance/libs/getCompanyComplianceModuleStatus';
import { VerificationStatus } from '../../Verification/lib/steps/types';
import getFinancialInfoStatus from './getHasFinancialInfo';

const getModuleStatus = ({
  companyProfile,
  shouldAskSanctionsDeclarationQuestions,
}: {
  companyProfile: Pick<
    OnboardingCompanyProfile,
    | 'isMicro'
    | 'legalAnnualTurnOver'
    | 'legalNumberOfEmployeeRange'
    | 'legalShareCapital'
    | 'legalForm'
    | 'isComplianceFilled'
    | 'isEligibleToOnboard'
  >;
  shouldAskSanctionsDeclarationQuestions: boolean;
}): VerificationStatus => {
  const { isMicro } = companyProfile;

  const complianceModuleStatus = getCompanyComplianceModuleStatus({
    companyProfile,
    shouldAskSanctionsDeclarationQuestions,
  });

  if (
    complianceModuleStatus === CompanyComplianceModuleStatus.ToDo ||
    complianceModuleStatus === CompanyComplianceModuleStatus.Refused
  ) {
    return VerificationStatus.ToDo;
  }

  if (isMicro) {
    if (complianceModuleStatus === CompanyComplianceModuleStatus.Complete) {
      return VerificationStatus.Completed;
    }
    if (complianceModuleStatus === CompanyComplianceModuleStatus.Unnecessary) {
      return VerificationStatus.Irrelevant;
    }
  }

  return getFinancialInfoStatus(companyProfile);
};

export default getModuleStatus;
